import _ from 'lodash'
import axios, { CancelToken } from 'axios'

let tokens = {}

/**
 * cancel
 *
 * Cancel specific request by given cancel token keys
 *
 * @param {*} keys, array of keys of axios cancel token
 */
const cancel = (keys = []) => {
  _.forEach(keys, (key) => {
    if (_.isFunction(tokens[key])) {
      tokens[key]()
    }
  })
  tokens = _.omit(tokens, keys)
}

/**
 * cancelAll
 *
 * Only use this if you are sure you know what you are doing as this will cancel
 * ALL requests, i.e. if called in componentWillUnmount it will potentially cancel
 * the request on the next mounted component depending on when componentWillUnmount is executed.
 *
 * If in doubt always pass the keys to cancel
 *
 * @param {*} keys
 */
const cancelAll = (keys = []) => {
  cancel(keys || Object.keys(tokens))
}

// TODO: not currently used
const cancelToken = (key) => new CancelToken((c) => {
  tokens[key] = () => c(`${key}: Operation cancelled by user`)
})

const add = (key, c) => {
  tokens[key] = c
}

const isCancel = (error) => axios.isCancel(error)

const getErrorObject = () => ({ isCancel: true })

export default {
  cancelToken,
  cancelAll,
  cancel,
  add,
  getErrorObject,
  isCancel,
}
